import styled from 'styled-components';
import {Button} from '@/components/Button';
import {PopupIconComponent} from '@/components/Icons';
import {Typography, typographyStyle} from '@/components/Typography';
import {interceptProps} from '@/styled-components';
import {palette} from '@/styles';

export const FilterChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const FilterChip = styled.div`
  background-color: #e3f6f8;
  color: ${palette.teal200};
  display: flex;
  align-items: center;
  padding: 5px 8px;
  border-radius: 50px;
  ${{...typographyStyle.medium12}}
`;

export const TextLink = styled.div`
  cursor: pointer;
  color: ${palette.linkPrimary};
  font-weight: 700;
  ${{...typographyStyle.medium12}}
`;

export const OutLink = styled(TextLink)`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const OutLinkIcon = styled(PopupIconComponent).attrs({
  color: '#4A81D5',
})`
  width: 16px;
  height: 16px;
  margin-left: 2px;
`;

export const OptionLabel = styled(Typography).attrs({
  variant: 'medium12',
  color: palette.textSecondary,
  fontWeight: 500,
})`
  flex-shrink: 0;
`;

export const OptionName = styled(OptionLabel)`
  display: block;
  padding: 0 8px;
`;

export const FilterOptionButtonGroup = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  margin-top: 4px;
`;

export const FilterOptionButton = styled(Button)
  .withConfig({
    shouldForwardProp: interceptProps(['active']),
  })
  .attrs(({active}: {active: boolean}) => ({
    size: 'regular',
    variant: active ? 'fill' : 'outline',
    color: active ? 'primary' : 'black',
  }))`
flex-shrink: 0;
`;
